import styled from "styled-components";
import ReactCodeInput from "react-code-input";

export const CodeInput = styled(ReactCodeInput)`
  input {
    appearance: textfield;
    text-align: center;
    border-radius: 1rem;
    padding-bottom: 0.25rem;
    border: 1px solid #1e5456;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 10px 0px;
    margin: 10px;
    width: 6rem;
    height: 6rem;
    font-size: 32px;
    box-sizing: border-box;
    color: #1e5456;
    font-weight: 600;
  }

  /* Chrome, Safari, Edge, Opera */

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */

  input[type="number"] {
    -moz-appearance: textfield;
  }
`;

export const PinCodeFormItemWrapper = styled.div`
  display: flex;
  justify-content: center;
  text-align: center;
  margin-bottom: 1rem;
`;
